interface LoadingSpinnerProps {
  message?: string;
}

export default function LoadingSpinner({ message = 'Cargando...' }: LoadingSpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center py-8">
      <div className="vintage-paper aged-paper p-6 rounded-[15%] shadow-lg">
        <div className="flex items-center gap-3">
          <div className="w-6 h-6 border-2 border-sepia-300 border-t-sepia-800 rounded-full animate-spin"></div>
          <span className="text-sepia-700 font-ui text-sm">{message}</span>
        </div>
      </div>
    </div>
  );
}